import { Button, Divider, Dropdown, Input } from "antd";
import { useMemo } from "react";
import { SearchOutlined } from "@ant-design/icons";
import { Icon } from "../../../../components/icon/icon";
import useSearch from "../../user-management/useSearch";
import encodeSvgWithColor from "../../../../common/utils/encodeSvgWithColor";

const TriggeredAddTaskItem = ({ items, handleAddTask }) => {
  const { search, handleUpdateSearchValue } = useSearch();

  const list = useMemo(() => {
    const availableTasks = search
      ? items.filter((item) =>
          (item.DailyTask ? item.DailyTask.title : item.name || item.title)
            ?.toLowerCase()
            .includes(search.toLowerCase())
        )
      : items;

    return availableTasks.map((item, index) => {
      const { avatar, avatarColor, backgroundColor, title, name, id } =
        item.DailyTask || item;

      return {
        key: id + index,
        label: title ?? name,
        icon: (avatar || backgroundColor) && (
          <div
            className="calendar-icon-wrapper"
            style={{ backgroundColor }}
          >
            {avatar && (
              <img
                style={{ width: 12 }}
                src={encodeSvgWithColor(avatar, avatarColor)}
                alt="avatar"
              />
            )}
          </div>
        ),
        onClick: () => handleAddTask(item),
      };
    });
  }, [items, search]);

  const dropdownRender = (content) => {
    return (
      <div style={{ padding: "0 10px", backgroundColor: "transparent" }}>
        <div
          className="ant-dropdown ant-dropdown-menu"
          style={{ boxShadow: "rgba(149, 157, 165, 0.2) 0px 8px 24px" }}
        >
          <div style={{ display: "flex", marginLeft: 15, padding: "3px" }}>
            <SearchOutlined />
            <Input
              variant="borderless"
              value={search}
              placeholder="Search task"
              onChange={handleUpdateSearchValue}
            />
          </div>
          <Divider style={{ margin: "0 0 10px 0" }} />
          <div style={{ maxHeight: 260, overflow: "auto" }}>
            {content}
          </div>
        </div>
      </div>
    );
  };

  return (
    <Dropdown
      menu={{ items: list }}
      trigger={["click"]}
      styles={{ root: { width: "max-content" } }}
      popupRender={dropdownRender}
    >
      <div>
        <Button
          type="text"
          icon={<Icon name="add" color="text-1" />}
          style={{ color: "var(--text-1)", fontSize: 14, paddingLeft: 8, height: 40 }}
        >
          Add task
        </Button>
      </div>
    </Dropdown>
  );
};

export default TriggeredAddTaskItem;